import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import homeRoutes from "@/views/home/router/Index";
import pymtRoutes from "@/views/pymt/router/Index";
import forSite from "./forSite";

Vue.use(VueRouter);

const freyaLogin: Array<RouteConfig> = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/views/auth/Login.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/Login.vue"),
  },
];

let routes = "TRUK" === forSite ? [...homeRoutes] : [...freyaLogin];

routes = [
  ...routes,
  ...pymtRoutes,
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About.vue"),
  },
  {
    path: "/",
    component: () => import("@/views/UIWrapper.vue"),
    children: [
      {
        name: "My Account",
        path: "account",
        component: () => import("@/views/account/Account.vue"),
      },
      {
        name: "Allocations",
        path: "allocation",
        component: () => import("@/views/allocation/Allocations.vue"),
      },
      {
        name: "Create Allocation",
        path: "allocation/create",
        component: () => import("@/views/allocation/AllocationEdit.vue"),
      },
      {
        name: "Edit Allocation",
        path: "allocation/:id",
        component: () => import("@/views/allocation/AllocationEdit.vue"),
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/Dashboard.vue"),
      },
      {
        name: "Quotations",
        path: "quot",
        component: () => import("@/views/quot/QuotRequest.vue"),
      },
      {
        name: "Cargo",
        path: "cargo",
        component: () => import("@/views/cargo/Cargo.vue"),
      },
      {
        name: "Create Cargo",
        path: "cargo/create",
        component: () => import("@/views/cargo/CargoEdit.vue"),
      },
      {
        name: "Edit Cargo",
        path: "cargo/:id",
        component: () => import("@/views/cargo/CargoEdit.vue"),
      },
      {
        name: "Trip",
        path: "trip",
        component: () => import("@/views/trip/Trips.vue"),
      },
      {
        name: "Create Trip",
        path: "trip/create",
        component: () => import("@/views/trip/TripEdit.vue"),
      },
      {
        name: "Edit Trip",
        path: "trip/:id",
        component: () => import("@/views/trip/TripEdit.vue"),
      },
      {
        name: "API Logs",
        path: "apilogs",
        component: () => import("@/views/apilog/APILogs.vue"),
      },
      {
        name: "View API Log",
        path: "apilog/:id",
        component: () => import("@/views/apilog/APILogEdit.vue"),
      },
      {
        name: "Payment Transactions",
        path: "paymentlog",
        component: () => import("@/views/paymentlog/PaymentLog.vue"),
      },
      {
        name: "Truck Types",
        path: "trucktypes",
        component: () => import("@/views/master/VehicleCategory.vue"),
      },
      {
        name: "Entities",
        path: "entity",
        component: () => import("@/views/entity/Entity.vue"),
      },
      {
        name: "Create Entity",
        path: "entity/create",
        component: () => import("@/views/entity/EntityEdit.vue"),
      },
      {
        name: "Edit Entity",
        path: "entity/:id",
        component: () => import("@/views/entity/EntityEdit.vue"),
      },
      {
        name: "Clone Entity",
        path: "entity/:clone_id/clone",
        component: () => import("@/views/entity/EntityEdit.vue"),
      },
      {
        name: "Invoice Setup",
        path: "invoicesetup",
        component: () => import("@/views/invoicesetup/InvoiceSetup.vue"),
      },
      {
        name: "Handover",
        path: "handover",
        component: () => import("@/views/handover/Handover.vue"),
      },
      {
        name: "Create Handover",
        path: "handover/create",
        component: () => import("@/views/handover/HandoverEdit.vue"),
      },
      {
        name: "Edit Handover",
        path: "handover/:id",
        component: () => import("@/views/handover/HandoverEdit.vue"),
      },
      {
        name: "Rate Cards",
        path: "ratecard",
        component: () => import("@/views/ratecard/RateCard.vue"),
      },
      {
        name: "Compliances",
        path: "settings/compliance",
        component: () => import("@/views/compliance/Compliance.vue"),
      },
      {
        name: "Inventory",
        path: "settings/inventory",
        component: () => import("@/views/inventory/Inventory.vue"),
      },
      {
        name: "Create Inventory",
        path: "settings/inventory/create",
        component: () => import("@/views/inventory/InventoryEdit.vue"),
      },
      {
        name: "Edit Inventory",
        path: "settings/inventory/:id",
        component: () => import("@/views/inventory/InventoryEdit.vue"),
      },
      {
        name: "Add Bill",
        path: "bill/create",
        component: () => import("@/views/bill/BillEdit.vue"),
      },
      {
        name: "Edit Bill",
        path: "bill/:id",
        component: () => import("@/views/bill/BillEdit.vue"),
      },
      {
        name: "Article Inventory",
        path: "inventories",
        component: () => import("@/views/articleinventory/Inventories.vue"),
      },
      {
        name: "Edit Article Inventory",
        path: "inventory/:id",
        component: () => import("@/views/articleinventory/InventoryEdit.vue"),
      },
      {
        name: "Fund Accounts",
        path: "settings/fundaccounts",
        component: () => import("@/views/fundAccount/FundAccount.vue"),
      },
      {
        name: "Fund Account Create",
        path: "settings/fundaccounts/create",
        component: () => import("@/views/fundAccount/FundAccountEdit.vue"),
      },
      {
        name: "Edit Fund Account",
        path: "settings/fundaccounts/:id",
        component: () => import("@/views/fundAccount/FundAccountEdit.vue"),
      },
      {
        name: "Account Transactions",
        path: "settings/transactions",
        component: () => import("@/views/transactions/AcTrans.vue"),
      },
      {
        name: "Account Transactions Create",
        path: "settings/transactions/create",
        component: () => import("@/views/transactions/AcTransEdit.vue"),
      },
      {
        name: "Account Transactions Edit",
        path: "settings/transactions/:id",
        component: () => import("@/views/transactions/AcTransEdit.vue"),
      },
      {
        name: "City Groups",
        path: "settings/citygroup",
        component: () => import("@/views/citygroup/CityGroup.vue"),
      },
      {
        name: "Create City Group",
        path: "settings/citygroup/create",
        component: () => import("@/views/citygroup/CityGroupEdit.vue"),
      },
      {
        name: "Edit City Group",
        path: "settings/citygroup/:id",
        component: () => import("@/views/citygroup/CityGroupEdit.vue"),
      },
      {
        name: "Templates",
        path: "settings/template",
        component: () => import("@/views/template/Template.vue"),
      },
      {
        name: "Create Template",
        path: "settings/template/create",
        component: () => import("@/views/template/TemplateEdit.vue"),
      },
      {
        name: "Edit Template",
        path: "settings/template/:id",
        component: () => import("@/views/template/TemplateEdit.vue"),
      },
      {
        name: "Bird Eye",
        path: "birdeye",
        component: () => import("@/views/birdeye/BirdEye.vue"),
      },
      {
        name: "Tax Slabs",
        path: "taxslab",
        component: () => import("@/views/taxslab/TaxSlab.vue"),
      },
      {
        name: "Create Tax Slab",
        path: "taxslab/create",
        component: () => import("@/views/taxslab/TaxSlabEdit.vue"),
      },
      {
        name: "Edit Tax Slab",
        path: "taxslab/:id",
        component: () => import("@/views/taxslab/TaxSlabEdit.vue"),
      },
      {
        name: "Invoice Configuration",
        path: "invoiceconfig",
        component: () => import("@/views/invoiceconfig/InvoiceConfig.vue"),
      },
      {
        name: "Create Invoice Configuration",
        path: "invoiceconfig/create",
        component: () => import("@/views/invoiceconfig/InvoiceConfigEdit.vue"),
      },
      {
        name: "Edit Invoice Configuration",
        path: "invoiceconfig/:id",
        component: () => import("@/views/invoiceconfig/InvoiceConfigEdit.vue"),
      },
      {
        name: "Tickets",
        path: "ticket",
        component: () => import("@/views/ticket/Tickets.vue"),
      },
      {
        name: "Create Ticket",
        path: "ticket/create",
        component: () => import("@/views/ticket/TicketEdit.vue"),
      },
      {
        name: "Edit Ticket",
        path: "ticket/:id",
        component: () => import("@/views/ticket/TicketEdit.vue"),
      },
      {
        name: "Brandings",
        path: "branding",
        component: () => import("@/views/branding/Brandings.vue"),
      },
      {
        name: "Create Branding",
        path: "branding/create",
        component: () => import("@/views/branding/BrandingEdit.vue"),
      },
      {
        name: "Edit Branding",
        path: "branding/:id",
        component: () => import("@/views/branding/BrandingEdit.vue"),
      },
      {
        name: "Screens",
        path: "screen",
        component: () => import("@/views/screen/Screens.vue"),
      },
      {
        name: "Create Screen",
        path: "screen/create",
        component: () => import("@/views/screen/ScreenEdit.vue"),
      },
      {
        name: "Edit Screen",
        path: "screen/:id",
        component: () => import("@/views/screen/ScreenEdit.vue"),
      },
      {
        name: "Campuses",
        path: "settings/campuses",
        component: () => import("@/views/campus/Campuses.vue"),
      },
      {
        name: "Create Campus",
        path: "settings/campus/create",
        component: () => import("@/views/campus/CampusEdit.vue"),
      },
      {
        name: "Edit Campus",
        path: "settings/campus/:id",
        component: () => import("@/views/campus/CampusEdit.vue"),
      },
      {
        name: "Garage",
        path: "settings/garage",
        component: () => import("@/views/garage/Garage.vue"),
      },
      {
        name: "Create garage",
        path: "settings/garage/create",
        component: () => import("@/views/garage/GarageEdit.vue"),
      },
      {
        name: "Edit Garage",
        path: "settings/garage/:id",
        component: () => import("@/views/garage/GarageEdit.vue"),
      },
      {
        name: "Holidays",
        path: "holidays",
        component: () => import("@/views/holidayconf/Holidays.vue"),
      },
      {
        name: "Work Shift",
        path: "shift",
        component: () => import("@/views/shift/Shift.vue"),
      },
      {
        name: "Create Shift",
        path: "shift/create",
        component: () => import("@/views/shift/ShiftEdit.vue"),
      },
      {
        name: "Edit Shift",
        path: "shift/:id",
        component: () => import("@/views/shift/ShiftEdit.vue"),
      },

      {
        name: "Create Holiday",
        path: "holiday/create",
        component: () => import("@/views/holidayconf/HolidayEdit.vue"),
      },
      {
        name: "Edit Holiday",
        path: "holiday/:id",
        component: () => import("@/views/holidayconf/HolidayEdit.vue"),
      },
      {
        name: "Settings",
        path: "settings",
        component: () => import("@/views/settings/SettingsMenu.vue"),
      },
      {
        name: "Demo",
        path: "demo",
        component: () => import("@/views/demo/Demo.vue"),
      },
      {
        name: "Demo2",
        path: "demo2",
        component: () => import("@/views/demo/Demo2.vue"),
      },
      {
        name: "Demo3",
        path: "demo3",
        component: () => import("@/views/demo/Demo3.vue"),
      },
      {
        path: "/settings/clients",
        name: "Clients",
        component: () => import("@/views/client/Clients.vue"),
      },
      {
        path: "/settings/client/add",
        name: "Client Add",
        component: () => import("@/views/client/ClientAdd.vue"),
      },
      {
        path: "/settings/client/:id",
        name: "Client Edit",
        component: () => import("@/views/client/ClientEdit.vue"),
      },
      {
        path: "/settings/staticcontent/create",
        name: "Add Static Content",
        component: () => import("@/views/staticcontent/StaticContentEdit.vue"),
      },
      {
        path: "/settings/staticcontent/:id",
        name: "Edit Static Content",
        component: () => import("@/views/staticcontent/StaticContentEdit.vue"),
      },
      {
        path: "/settings/vendor",
        name: "Vendor",
        component: () => import("@/views/vendor/Vendor.vue"),
      },
      {
        path: "/settings/vendor/add",
        name: "Vendor Add",
        component: () => import("@/views/vendor/VendorAdd.vue"),
      },
      {
        path: "/settings/vendor/:id",
        name: "Vendor Edit",
        component: () => import("@/views/vendor/VendorEdit.vue"),
      },
      {
        name: "Icons",
        path: "components/icons",
        component: () => import("@/components/core/Icons.vue"),
      },
      {
        name: "Typography",
        path: "components/typography",
        component: () => import("@/components/core/Typography.vue"),
      },
      {
        name: "Zone",
        path: "settings/zone",
        component: () => import("@/views/zone/Zone.vue"),
      },
      {
        name: "Zone Edit",
        path: "settings/zone/create",
        component: () => import("@/views/zone/ZoneEdit.vue"),
      },
      {
        name: "Edit Zone",
        path: "settings/zone/:id",
        component: () => import("@/views/zone/ZoneEdit.vue"),
      },
      {
        name: "User Role",
        path: "role",
        component: () => import("@/views/role/Role.vue"),
      },
      {
        name: "Add User Role",
        path: "role/create",
        component: () => import("@/views/role/RoleEdit.vue"),
      },
      {
        name: "Edit User Role",
        path: "role/:id",
        component: () => import("@/views/role/RoleEdit.vue"),
      },

      {
        name: "Supervisor",
        path: "/settings/supervisor",
        component: () => import("@/views/supervisor/Supervisor.vue"),
      },
      {
        name: "Add Supervisor",
        path: "/settings/supervisor/create",
        component: () => import("@/views/supervisor/SupervisorEdit.vue"),
      },
      {
        name: "Edit Supervisor",
        path: "/settings/supervisor/:id",
        component: () => import("@/views/supervisor/SupervisorEdit.vue"),
      },
      {
        name: "Booking",
        path: "booking",
        component: () => import("@/views/booking/Bookings.vue"),
      },
      {
        name: "Add Booking",
        path: "booking/create",
        component: () => import("@/views/booking/BookingEdit.vue"),
      },
      {
        name: "Edit Booking",
        path: "booking/:id",
        component: () => import("@/views/booking/BookingEdit.vue"),
      },
      {
        name: "Invoice",
        path: "sales/invoices",
        component: () => import("@/views/invoice/Invoices.vue"),
      },
      {
        name: "Add Invoice",
        path: "sales/invoice/create",
        component: () => import("@/views/invoice/InvoiceEdit.vue"),
      },
      {
        name: "Manual Invoice",
        path: "sales/invoice/manual",
        component: () => import("@/views/invoice/ManualInvoice.vue"),
      },
      {
        name: "Edit Manual Invoice",
        path: "sales/invoice/manual/:id",
        component: () => import("@/views/invoice/ManualInvoice.vue"),
      },
      {
        name: "Edit Invoice",
        path: "sales/invoice/:id",
        component: () => import("@/views/invoice/InvoiceEdit.vue"),
      },
      {
        name: "Integrations",
        path: "integrations",
        component: () => import("@/views/integration/integrations.vue"),
      },
      {
        name: "Create Integration",
        path: "integration/create",
        component: () => import("@/views/integration/integrationEdit.vue"),
      },
      {
        name: "Edit integration",
        path: "integration/:id",
        component: () => import("@/views/integration/integrationEdit.vue"),
      },
      {
        name: "Booking Setting",
        path: "setting/booking",
        component: () => import("@/views/settings/Setting.vue"),
      },
      {
        name: "Journey Gap",
        path: "journey/gap",
        component: () => import("@/views/settings/JourneyGap.vue"),
      },
      {
        name: "Route Setting",
        path: "setting/route",
        component: () => import("@/views/settings/RouteSetting.vue"),
      },
      {
        name: "Other Setting",
        path: "other/setting",
        component: () => import("@/views/settings/OtherSetting.vue"),
      },
      {
        name: "Roster Setting",
        path: "roster/setting",
        component: () => import("@/views/settings/RoutingSetting.vue"),
      },
      {
        name: "Sales",
        path: "sales",
        component: () => import("@/views/tariffInvoice/BillingMenu.vue"),
      },
      {
        name: "Tariffs",
        path: "tariff/grid",
        component: () => import("@/views/tariff_new/TariffGrid.vue"),
      },
      {
        name: "Add Tariff",
        path: "tariff/create",
        component: () => import("@/views/tariff_new/TariffCreate.vue"),
      },
      {
        name: "Edit Tariff",
        path: "tariff/edit/:id",
        component: () => import("@/views/tariff_new/TariffCreate.vue"),
      },
      // {
      //   name: "Edit Tariff",
      //   path: "tariff/:id",
      //   component: () => import("@/views/tariff/TariffEdit.vue"),
      // },
      // {
      //   name: "Clone Tariff",
      //   path: "tariff/:clone_id/clone",
      //   component: () => import("@/views/tariff/TariffEdit.vue"),
      // },
      {
        name: "Payment Gateway",
        path: "settings/paymentgateway",
        component: () => import("@/views/settings/PaymentGateway.vue"),
      },
      {
        name: "Add Payment Gateway",
        path: "settings/paymentgateway/create",
        component: () => import("@/views/settings/PaymentGatewayEdit.vue"),
      },
      {
        name: "Edit Payment Gateway",
        path: "settings/paymentgateway/:id",
        component: () => import("@/views/settings/PaymentGatewayEdit.vue"),
      },
      {
        name: "Fuel Add",
        path: "fuel/create",
        component: () => import("@/views/fuel/consumption/ConsumptionEdit.vue"),
      },
      {
        name: "Fuel Edit",
        path: "fuel/:id",
        component: () => import("@/views/fuel/consumption/ConsumptionEdit.vue"),
      },
      {
        name: "Fuels",
        path: "fuel",
        component: () => import("@/views/fuel/Fuel.vue"),
      },
      {
        name: "Fuel Pump Create",
        path: "fuelpump/create",
        component: () => import("@/views/fuel/fuelpump/FuelPumpEdit.vue"),
      },
      {
        name: "Fuel Pump Edit",
        path: "fuelpump/:id",
        component: () => import("@/views/fuel/fuelpump/FuelPumpEdit.vue"),
      },
      {
        name: "Fuel Price Create",
        path: "fuelprice/create",
        component: () => import("@/views/fuel/fuelprice/FuelPriceEdit.vue"),
      },
      {
        name: "Fuel Price Edit",
        path: "fuelprice/:id",
        component: () => import("@/views/fuel/fuelprice/FuelPriceEdit.vue"),
      },
      {
        name: "My Profile",
        path: "profile",
        component: () => import("@/views/profile/MyProfile.vue"),
      },
      {
        name: "Vehicles",
        path: "vehicles",
        component: () => import("@/views/vehicle/Vehicles.vue"),
      },
      {
        name: "Vehicle Create",
        path: "vehicle/create",
        component: () => import("@/views/vehicle/VehicleEdit.vue"),
      },
      {
        name: "Vehicle Edit",
        path: "vehicle/:id",
        component: () => import("@/views/vehicle/VehicleEdit.vue"),
      },
      {
        name: "Employees",
        path: "drivers",
        component: () => import("@/views/driver/Drivers.vue"),
      },
      {
        name: "Employee Create",
        path: "driver/create",
        component: () => import("@/views/driver/DriverEdit.vue"),
      },
      {
        name: "Employee Edit",
        path: "driver/:id",
        component: () => import("@/views/driver/DriverEdit.vue"),
      },
      {
        name: "Vehicles & Drivers",
        path: "vehicledriver",
        component: () => import("@/views/vehicledriver/VehicleDriver.vue"),
      },
      {
        name: "Offer",
        path: "offer",
        component: () => import("@/views/report/offer/Offer.vue"),
      },
      {
        name: "Offer Create",
        path: "offer/create",
        component: () => import("@/views/report/offer/OfferEdit.vue"),
      },
      {
        name: "Offer Edit",
        path: "offer/:id",
        component: () => import("@/views/report/offer/OfferEdit.vue"),
      },
      {
        name: "Purchases",
        path: "purchases",
        component: () => import("@/views/purchase/Purchases.vue"),
      },
      {
        name: "Expenses",
        path: "expenses",
        component: () => import("@/views/expense/Expenses.vue"),
      },
      {
        name: "Expense Create",
        path: "expense/create",
        component: () => import("@/views/expense/ExpenseEdit.vue"),
      },
      {
        name: "Expense Edit",
        path: "expense/:id",
        component: () => import("@/views/expense/ExpenseEdit.vue"),
      },
      {
        name: "Bills",
        path: "bills",
        component: () => import("@/views/bill/Bills.vue"),
      },
      {
        name: "Payments Received",
        path: "paymentreceived",
        component: () => import("@/views/paymentreceived/PaymentsReceived.vue"),
      },
      {
        name: "Payment Received Create",
        path: "paymentreceived/create",
        component: () =>
          import("@/views/paymentreceived/PaymentReceivedEdit.vue"),
      },
      {
        name: "Payment Received Edit",
        path: "paymentreceived/:id",
        component: () =>
          import("@/views/paymentreceived/PaymentReceivedEdit.vue"),
      },
      {
        name: "Payments Done",
        path: "paymentdones",
        component: () => import("@/views/paymentdone/PaymentDones.vue"),
      },
      {
        name: "Add Payments Done",
        path: "paymentdone/create",
        component: () => import("@/views/paymentdone/PaymentDoneEdit.vue"),
      },
      {
        name: "Edit Payments Done",
        path: "paymentdone/:id",
        component: () => import("@/views/paymentdone/PaymentDoneEdit.vue"),
      },
      {
        name: "Payments Pending",
        path: "paymentpending",
        component: () => import("@/views/paymentpending/PaymentPending.vue"),
      },
      {
        name: "Opening Balance",
        path: "openingbalances",
        component: () => import("@/views/openingbalance/OpeningBalances.vue"),
      },
      {
        name: "Add Opening Balance",
        path: "openingbalance/create",
        component: () =>
          import("@/views/openingbalance/OpeningBalanceEdit.vue"),
      },
      {
        name: "Edit Opening Balance",
        path: "openingbalance/:id",
        component: () =>
          import("@/views/openingbalance/OpeningBalanceEdit.vue"),
      },
      {
        name: "Reports",
        path: "reports",
        component: () => import("@/views/reports/ReportsMenu.vue"),
      },
      {
        name: "SMS Logs",
        path: "reports/smslog",
        component: () => import("@/views/sms/SMSLogs.vue"),
      },
      {
        name: "SOS Logs",
        path: "reports/soslog",
        component: () => import("@/views/sos/SOSLogs.vue"),
      },
      {
        name: "Access Logs",
        path: "reports/accesslog",
        component: () => import("@/views/access/AccessLogs.vue"),
      },
      {
        name: "Incidents",
        path: "reports/incidents",
        component: () => import("@/views/incident/Incident.vue"),
      },
      {
        name: "Feedback",
        path: "reports/feedback",
        component: () => import("@/views/reports/feedback/Feedback.vue"),
      },
      {
        name: "General Revenue",
        path: "reports/revenue/:type",
        component: () => import("@/views/reports/revenue/GeneralRevenue.vue"),
      },
      {
        name: "Trip Revenue",
        path: "reports/trip/revenue",
        component: () => import("@/views/reports/revenue/TripRevenue.vue"),
      },
      {
        name: "Vehicle Revenue Report",
        path: "reports/vehicle/revenue",
        component: () => import("@/views/reports/vehicle/VehicleRevenue.vue"),
      },
      {
        name: "SMS Setup",
        path: "settings/smsSetup",
        component: () => import("@/views/settings/SmsSetup.vue"),
      },
      {
        name: "SMS Setup",
        path: "settings/emailSetup",
        component: () => import("@/views/settings/EmailSetup.vue"),
      },
      {
        name: "Helplines",
        path: "settings/helplines",
        component: () => import("@/views/settings/HelpLine.vue"),
      },
      {
        name: "Branches",
        path: "branch",
        component: () => import("@/views/branch/Branch.vue"),
      },
      {
        name: "Create Branch",
        path: "branch/create",
        component: () => import("@/views/branch/BranchEdit.vue"),
      },
      {
        name: "Edit Branch",
        path: "branch/:id",
        component: () => import("@/views/branch/BranchEdit.vue"),
      },

      // Tables
      // {
      //   name: 'Regular Tables',
      //   path: 'tables/regular-tables',
      //   component: () => import('@/components/core/RegularTables.vue'),
      // },
      // Maps
      // {
      //   name: 'Google Maps',
      //   path: 'maps/google-maps',
      //   component: () => import('@/components/core/GoogleMaps.vue'),
      // },

      // {
      //   path: "/",
      //   name: "Home",
      //   component: () => import("@/views/home/layouts/HomeWrapper.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       name: "FourOhFour",
      //       component: () => import("@/views/404/Index.vue"),
      //     },
      //   ],
      // },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
